<template>
  <layout :title-text="title">
    <div slot="content" class="media-container">
      <img src="../../assets/images/img_support_media.png" draggable="false"/>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
export default {
  components: {
    Layout
  },
  data () {
    return {
      title: '支持媒体'
    }
  }
}
</script>

<style lang="less" scoped>
.media-container {
  width: 100%;
  height: 120px;
}
</style>
